import type { ReactNode } from 'react';

import { IndicadoresPage } from './IndicadoresPage';
import { MapaInterativoPage } from './MapaInterativoPage';
import { NotificacoesAnaliticasPage } from './NotificacoesAnaliticasPage';
import { VisaoGeralPage } from './VisaoGeralPage';
import { RelatoriosAnaliticosPage } from './RelatoriosAnaliticosPage';

/**
 * As telas de `/operacao`, por caminho.
 *
 * Mesmo desenho de `parametrizacao/telas.tsx`: o `App.tsx` só espalha este
 * objeto dentro de `TELAS_PRONTAS`, e a rota continua nascendo do mapa de
 * navegação (`nucleo/navegacao/mapa.ts`). Aqui não se declara rota — só se diz
 * qual tela serve o caminho que o mapa já criou.
 */
export const TELAS_DE_ANALISES: Record<string, ReactNode> = {
  '/operacao': <VisaoGeralPage />,
  '/operacao/relatorios': <RelatoriosAnaliticosPage />,
  '/operacao/kpis': <IndicadoresPage />,
  '/operacao/mapa': <MapaInterativoPage />,
  '/operacao/notificacoes': <NotificacoesAnaliticasPage />,
};
